<template>
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout
            :meun="meunItem"
            :title="meunTitle"
            :title2="headTitle"
          ></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <h3 class="title">{{ headTitle }}</h3>
            <div class="aLine"></div>
            <div class="tableInfo">
              <div class="input_div" v-if="info.id">
                <p>学号</p>
                <span>{{info.student_no}}</span>
              </div>
              <div class="input_div" v-if="info.id">
                <p>姓名</p>
                <span>{{info.name}}</span>
              </div>
              <div style="clear: both"></div>
              <div class="input_div">
                <p>回忆图片</p>
                <input
                  type="file"
                  accept="image/*"
                  style="display: none"
                  id="uploadfile"
                  @change="openFolder"
                />
                <el-button size="mini" @click="openImage()"
                  >选择本地图片</el-button
                >
                <el-image class="imageDiv" :src="imageUrl" fit="scale-down">
                  <div
                    slot="error"
                    class="image-slot"
                    style="position: absolute; top: 50%; left: 50%"
                  >
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <div style="clear: both"></div>
              <div class="input_div">
                <p>回忆内容</p>
                <el-input
                  type="textarea"
                  class="input"
                  v-model="info.content"
                  placeholder="请输入"
                  row="10"
                  maxlength="200"
                ></el-input>
              </div>
              <div class="input_div">
                <p>排序</p>
                <el-input
                  type="number"
                  class="input"
                  v-model="info.order"
                  placeholder="排序数字，正整数，默认1000"
                ></el-input>
              </div>
              <div style="clear: both"></div>
              <div class="input_div">
                <p>是否通过</p>
                <el-select
                  class="input"
                  v-model="info.is_pass"
                  placeholder="请选择"
                >
                  <el-option
                    :value="0"
                    label="不通过"
                  ></el-option>
                  <el-option
                    :value="1"
                    label="通过"
                  ></el-option>
                </el-select>
              </div>
              <div style="clear: both"></div>
              <div class="input_div" v-if="info.is_pass === 0">
                <p>不通过备注</p>
                <el-input
                  type="textarea"
                  class="input"
                  v-model="info.is_pass_remark"
                  placeholder="请输入"
                  maxlength="200"
                ></el-input>
              </div>
              <div style="clear: both"></div>
              <div class="input_div">
                <p>是否发布</p>
                <el-select
                  class="input"
                  v-model="info.is_publish"
                  placeholder="请选择"
                >
                  <el-option
                    :value="0"
                    label="不发布"
                  ></el-option>
                  <el-option
                    :value="1"
                    label="发布"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <FootLayout v-on:saveEdit="saveEdit"></FootLayout>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import { URL_PATH, Editor_Config } from "@/config/config";
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayoutWxapp";
import FootLayout from "@/components/layout/footLayout";

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    FootLayout
  },
  data() {
    return {
      meunItem: null,
      meunTitle: "",
      headTitle: "",
      urlPath: URL_PATH,
      imageUrl: "",
      info: { order: 1000, update_time: '' }
    };
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      this.infoId = this.$route.query.id;
      this.headTitle = this.infoId == null ? "新增回忆" : "编辑回忆";
      this.getInfo();
    },
    // 获取详情
    getInfo() {
      var id = this.$route.query.id;
      if (id == null) return;
      var that = this;
      this.$api
        .wishesDetail({
          token: localStorage.getItem("token"),
          id: id
        })
        .then(({ data }) => {
          that.info = data.Data;
          that.imageUrl = that.urlPath + that.info.image;
        })
        .catch(({ error }) => {});
    },
    // 新增
    addWishes: function(form) {
      this.$api
        .wishesEdit(form)
        .then(({ data }) => {
          this.$router.back(-1);
        })
        .catch(({ error }) => {});
    },
    // 编辑
    updateWishes: function(form) {
      form.append("id", this.info.id);
      this.$api
        .wishesEdit(form)
        .then(({ data }) => {
          this.$router.back(-1);
        })
        .catch(({ error }) => {});
    },
    // 选择图片
    openImage() {
      document.getElementById("uploadfile").click();
    },
    openFolder(e) {
      var that = this;
      var image = e.target.files[0];
      var reader = new FileReader();
      reader.onload = function(evt) {
        that.imageUrl = evt.target.result;
      };
      reader.readAsDataURL(image);
      this.info.image = image;
    },
    // 保存
    saveEdit() {
      if (
        StrUtils.isEmpty(this.info.content) ||
        StrUtils.isEmpty(this.info.is_pass) ||
        StrUtils.isEmpty(this.info.is_publish) ||
        StrUtils.isEmpty(this.info.image) ||
        StrUtils.isEmpty(this.info.order)
      ) {
        this.$message.error("请先完善数据");
        return;
      }
      if (this.info.is_pass == 0) {
        if (StrUtils.isEmpty(this.info.is_pass_remark)) {
          this.$message.error("不通过备注不能为空");
          return;
        }
      }
      console.log(this.info);
      var form = new FormData();
      form.append("token", localStorage.getItem("token"));
      form.append("content", this.info.content);
      form.append("is_pass", this.info.is_pass);
      form.append("is_pass_remark", this.info.is_pass_remark);
      form.append("is_publish", this.info.is_publish);
      form.append("image", this.info.image);
      form.append("order", this.info.order);
      form.append("update_time", this.info.update_time);
      if (this.infoId) {
        this.updateWishes(form);
      } else {
        this.addWishes(form);
      }
    },
    proving(index) {
      switch (index) {
        case 0:
          this.info.mobile = this.info.mobile.replace(/\D/g, "");
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-top: 24px;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.operateText {
  font-size: 14px;
}

.input_div {
  width: 290px;
  margin-right: 120px;
  margin-bottom: 32px;
  float: left;
}
.input_div .input {
  width: 100%;
}
.input_div p {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
  margin-bottom: 8px;
}
.tips {
  font-size: 12px;
  margin-top: 12px;
  color: #595959;
}
</style>

<style lang="less">
/* element样式重置 start */
/* 去掉input尾部上下小箭头 start */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type="number"] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
/* 去掉input尾部上下小箭头 end */
</style>



// WEBPACK FOOTER //
// src/pages/wxapp/wishesAdd.vue